import { render, staticRenderFns } from "./ManagementCard.vue?vue&type=template&id=134a6d33&scoped=true&"
import script from "./ManagementCard.vue?vue&type=script&lang=js&"
export * from "./ManagementCard.vue?vue&type=script&lang=js&"
import style0 from "./ManagementCard.vue?vue&type=style&index=0&id=134a6d33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134a6d33",
  null
  
)

export default component.exports